import { getAssetsForGame } from 'constants/games/lvg/lvgAssets'
import { useLayoutV3State } from 'hooks/useLayoutV3State'
import { useMemo } from 'react'

export const useAssets = () => {
  const { currentGame } = useLayoutV3State()
  const newCurrentGame = currentGame.toLowerCase().replace('lvg_', 'lvg-')
  const currentGameAssets = useMemo(() => getAssetsForGame(newCurrentGame), [newCurrentGame])
  return { currentGameAssets }
}
